import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSidebar } from '../../hooks/useSidebar';
import { useAppStore } from '../../store/appStore';
import Badge from '../ui/Badge';
import { SIDEBAR_NAV } from '../../utils/constants';

const Sidebar: React.FC = () => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { sidebarOpen, closeSidebar } = useSidebar();
  const { stats } = useAppStore();

  const handleNav = (path: string) => {
    navigate(path);
    closeSidebar();
  };

  return (
    <>
      {/* Overlay */}
      {sidebarOpen && (
        <div
          onClick={closeSidebar}
          style={{
            display: 'none',
            position: 'fixed', inset: 0,
            background: '#FFF',
            zIndex: 'var(--z-overlay)' as any,
          }}
          className="sidebar-overlay-el"
        />
      )}

      <aside
        style={{
          position: 'fixed',
          top: 'var(--nav-height)', left: 0, bottom: 0,
          width: 260,
          background: 'var(--surface)',
          borderRight: '1px solid var(--border)',
          display: 'flex', flexDirection: 'column',
          zIndex: 'var(--z-sidebar)' as any,
          overflowY: 'auto',
          transition: 'transform var(--transition-slow)',
        }}
        className={`sidebar-el${sidebarOpen ? ' sidebar-open' : ''}`}
      >
        {/* Nav sections */}
        {SIDEBAR_NAV.map((sec) => (
          <div key={sec.section} style={{ padding: '16px 12px 0' }}>
            <div
              style={{
                fontSize: '0.64rem', fontWeight: 700, letterSpacing: '0.12em',
                color: 'var(--text-muted)', textTransform: 'uppercase',
                padding: '0 8px 8px',
              }}
            >
              {sec.section}
            </div>

            {sec.items.map((item) => {
              const active = location.pathname === item.path;
              return (
                <button
                  key={item.path}
                  onClick={() => handleNav(item.path)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 10,
                    padding: '9px 12px', borderRadius: 'var(--radius-sm)',
                    cursor: 'pointer', fontSize: '0.84rem', fontWeight: 500,
                    color: active ? 'var(--accent)' : 'var(--text-dim)',
                    background: active ? 'var(--accent-dim)' : 'transparent',
                    border: 'none', width: '100%', textAlign: 'left',
                    fontFamily: 'var(--font-sans)',
                    transition: 'all var(--transition-fast)',
                    marginBottom: 2,
                  }}
                  onMouseEnter={(e) => {
                    if (!active) {
                      (e.currentTarget as HTMLElement).style.background = 'var(--surface2)';
                      (e.currentTarget as HTMLElement).style.color = 'var(--text)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!active) {
                      (e.currentTarget as HTMLElement).style.background = 'transparent';
                      (e.currentTarget as HTMLElement).style.color = 'var(--text-dim)';
                    }
                  }}
                >
                  <span style={{ fontSize: 15, width: 20, textAlign: 'center' }}>{item.icon}</span>
                  <span style={{ flex: 1 }}>{item.label}</span>
                  {item.badge && <Badge color="purple">{item.badge}</Badge>}
                </button>
              );
            })}

            <div style={{ height: 1, background: 'var(--border)', margin: '10px 0 4px' }} />
          </div>
        ))}

        {/* Stats panel */}
        <div
          style={{
            marginTop: 'auto', padding: '16px 12px',
            borderTop: '1px solid var(--border)',
          }}
        >
          {[
            { label: 'TOTAL BUILDS', value: stats.builds },
            { label: 'APK SIZE',     value: `${stats.apkSize} MB` },
          ].map(({ label, value }) => (
            <div
              key={label}
              style={{
                background: 'var(--surface2)', borderRadius: 'var(--radius-md)',
                padding: '10px 12px', marginBottom: 8,
              }}
            >
              <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)', fontWeight: 700, letterSpacing: '0.06em' }}>
                {label}
              </div>
              <div style={{ fontSize: '1.2rem', fontWeight: 800, color: 'var(--accent)', fontFamily: 'var(--font-mono)', marginTop: 2 }}>
                {value}
              </div>
            </div>
          ))}
        </div>
      </aside>

      <style>{`
        .sidebar-el { transform: translateX(0); }
        @media (max-width: 900px) {
          .sidebar-el { transform: translateX(-260px); }
          .sidebar-el.sidebar-open { transform: translateX(0); }
          .sidebar-overlay-el { display: block !important; }
        }
      `}</style>
    </>
  );
};

export default Sidebar;
